import moment from "moment";
import React from "react";
import KenoBonusLogo from "../components/KenoBonusLogo";
import KenoLogo from "../components/KenoLogo";
import { BASE_10, DOLLAR_IN_CENTS } from "../constants";
import IKenoDraw from "../interfaces/IKenoDraw";
import ISelection from "../interfaces/ISelection";
import ITicket from "../interfaces/ITicket";
import { MOMENT_DATE_FORMAT } from "../settings";
import filterNumberSelections from "../utils/filterNumberSelections";
import formatDollar from "../utils/formatDollar";
import getTicketStatus from "../utils/getTicketStatus";
import getTicketStatusText from "../utils/getTicketStatusText";

interface IProps {
    currentDraw: IKenoDraw;
    ticket: ITicket;
    onClose(): void;
    onReplay(ticket: ITicket): void;
}

export default class TicketDetailsModal extends React.Component<IProps> {
    public render(): JSX.Element {
        const { currentDraw, onClose, onReplay, ticket } = this.props;
        const purchaseDate = moment.unix(ticket.createdTimestamp).format(MOMENT_DATE_FORMAT);

        const numberSelections: ISelection[] = ticket.selections ? filterNumberSelections(ticket.selections) : [];
        numberSelections.sort((a: ISelection, b: ISelection): number => {
            const aValue = a.outcome ? parseInt(a.outcome.name, BASE_10) : 0;
            const bValue = b.outcome ? parseInt(b.outcome.name, BASE_10) : 0;
            return aValue - bValue;
        });

        const bonusSelected = ticket.selections && ticket.selections.length !== numberSelections.length;

        const FULL_COLUMN_WIDTH = 2;

        const ticketStatus = getTicketStatus(ticket, currentDraw);
        const ticketStatusText = getTicketStatusText(ticket, currentDraw);

        const ticketDrawId = ticket.event ? ticket.event.externalId : "Unknown";

        return (
            <div className="modal is-active">
                <div
                    className="modal-background"
                    onClick={ onClose.bind(this) }
                ></div>
                <div className="modal-card">
                    <div className="modal-card-head">
                        <div className="modal-card-title">
                            Ticket #{ ticket.id } - Draw #{ ticketDrawId } -
                            { " " }
                            <span className={ ticketStatus === "live" ? "active" : "" }>
                                { ticketStatusText }
                            </span>
                            { ticketStatus === "completed" ? (
                                ` - ${ (ticket.amountWon > 0 ? "WINNER" : "NOT A WINNER") }`
                            ) : undefined }
                        </div>
                        <button
                            className="delete"
                            aria-label="close"
                            onClick={ onClose.bind(this) }
                        ></button>
                    </div>
                    <section className="modal-card-body">
                        <p className="has-text-centered">
                            <KenoLogo />
                        </p>
                        <div className="styled-selections">
                            { numberSelections.map((selection: ISelection): JSX.Element => {
                                if (!selection.outcome) {
                                    return (
                                        <span key={ selection.id }></span>
                                    );
                                }
                                const classes = ["selection"];
                                if (selection.pointsEarned) {
                                    classes.push("match");
                                }
                                return (
                                    <span
                                        key={ selection.id }
                                        className={ classes.join(" ") }
                                    >
                                        { selection.outcome.name }
                                    </span>
                                );
                            }) }
                        </div>
                        <div className="ticket-details">
                            <table className="row-form">
                                <tbody>
                                    <tr className="field">
                                        <th>Purchase Date:</th>
                                        <td>{ purchaseDate.toUpperCase() }</td>
                                    </tr>
                                    <tr className="field">
                                        <th>Ticket ID:</th>
                                        <td>{ ticket.id }</td>
                                    </tr>
                                    <tr className="field">
                                        <th>Draws:</th>
                                        <td>{ ticket.event ? ticket.event.externalId : "-" }</td>
                                    </tr>
                                    <tr className="field">
                                        <th>Wager per Draw:</th>
                                        <td>
                                            { ticket.wager ? (
                                                <var>${ formatDollar(ticket.wager / DOLLAR_IN_CENTS) }</var>
                                            ) : (
                                                <var>-</var>
                                            ) }
                                        </td>
                                    </tr>
                                    <tr className="field">
                                        <th>
                                            <KenoBonusLogo />
                                        </th>
                                        <td>{ bonusSelected ? "YES" : "NO" }</td>
                                    </tr>
                                    <tr>
                                        <th>Total:</th>
                                        <td>${ formatDollar(ticket.cost / DOLLAR_IN_CENTS) }</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={ FULL_COLUMN_WIDTH }>
                                            <button
                                                className="styled-button"
                                                type="button"
                                                onClick={ onClose.bind(this) }
                                            >Done</button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={ FULL_COLUMN_WIDTH }>
                                            <button
                                                className="styled-button outline"
                                                type="button"
                                                onClick={ onReplay.bind(this, ticket) }
                                            >Replay</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/TicketDetailsModal.tsx